import type { RouteComponent, RouteRecordRaw } from 'vue-router'

export type RouteKey =
  | 'home'
  | 'notFound'
  | 'preview'
  | 'post'
  | 'page'

export type RouteDef = {
  key: RouteKey
  component: RouteComponent
  meta?: RouteRecordRaw['meta']
  nameBase?: string
}

export const routeDefs: RouteDef[] = [
  {
    key: 'home',
    component: () => import('@/views/Home.vue'),
    nameBase: 'home',
    meta: { layout: 'DefaultLayout' },
  },
  {
    key: 'notFound',
    component: () => import('@/views/NotFound.vue'),
    nameBase: '404',
    meta: { layout: 'MinimalLayout' },
  },
  {
    key: 'preview',
    component: () => import('@/views/Preview.vue'),
    nameBase: 'preview',
    meta: { layout: 'DefaultLayout' },
  },
  {
    key: 'post',
    component: () => import('@/views/Post.vue'),
    nameBase: 'post',
    meta: { layout: 'DefaultLayout' },
  },
  {
    key: 'page',
    component: () => import('@/views/Page.vue'),
    nameBase: 'page',
    meta: { layout: 'DefaultLayout' },
  },
]
